import type { IApplicationState } from 'shared/types/redux';
import type { ILocation } from 'shared/types/locations';
import { getFilterLocation } from '../filters';
import { locationsListSelector } from './locationsListSelector';

export function currentLocationByFiltersSelector(state: IApplicationState): ILocation {
  const list = locationsListSelector(state);
  const location = getFilterLocation(state);

  return list.find(item => item.locationId === location) ?? list[0];
}
